import { ThemeFontFamily } from 'libs/theme/src/lib/theme-fontfamily';

export const labelStyles = {
  fontSize: '1rem',
  fontFamily: ThemeFontFamily.bold,
};
